import {
  AnyAction,
  Dispatch,
  Middleware,
  MiddlewareAPI
} from "@reduxjs/toolkit"
import { logout } from "../slices/auth"

const authMiddleware: Middleware =
  (store: MiddlewareAPI) =>
  (next: Dispatch<AnyAction>) =>
  (action: AnyAction) => {
    // Catch explicit session expired action
    if (action.type === "auth/sessionExpired") {
      store.dispatch(logout() as any)
      if (process.env.NODE_ENV === "production") {
        window.location.href = "https://app.bankingbridge.com/auth0/logout"
      } else {
        window.location.href = "/user/login"
      }
    }

    // Catch 401 errors from RTK Query rejected actions
    if (action.type?.endsWith("/rejected") && action.payload?.status === 401) {
      store.dispatch(logout() as any)
      if (process.env.NODE_ENV === "production") {
        window.location.href = "https://app.bankingbridge.com/auth0/logout"
      } else {
        window.location.href = "/user/login"
      }
    }

    return next(action)
  }

export default authMiddleware
